var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full lg:w-2/3"},[_c('div',{staticClass:"lg:rounded shadow bg-white text-orange-500 text-sm italic mt-2 mb-3 lg:my-1 px-2 py-1"},[_vm._t("text")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }